import Icon, { IconsVariant } from "../Icon/Icon";

interface HelperProps {
  onClick?: any;
  bg?: string;
  variants?: IconsVariant;
  text?: string;
}

const Helper = ({
  bg = "primary",
  variants = "question",
  onClick,
  text,
}: HelperProps) => {
  return (
    <div
      className="fixed bottom-0 right-0 z-[2] cursor-pointer items-center p-2"
      onClick={onClick}
      style={{ background: `var(--${bg})` }}
    >
      {text ? (
        <div className="text-[white]" style={{ fontWeight: "bold" }}>
          {text}
        </div>
      ) : (
        <Icon className="h-12 w-12 fill-white" variants={variants} />
      )}
    </div>
  );
};

export default Helper;
